import styled from "styled-components";

export const VerifyButtonRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
`;
